import React, { useState } from 'react';
import logo from './logo.png';

const UserList = () => {
    const [users, setUsers] = useState([]);

    const [formData, setFormData] = useState({
        empCode: '',
        empName: '',
        gender: '',
        contact: '',
        designation: '',
        department: '',
        location: '',
    });


    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Basic validation
        if (!formData.empCode || !formData.empName) {
            alert("Please fill in Employee Code and Name.");
            return;
        }

        // Add user to list
        setUsers(prev => [...prev, formData]);

        // Reset form
        setFormData({
            empCode: '',
            empName: '',
            gender: '',
            contact: '',
            designation: '',
            department: '',
            location: '',
        });

        // Close modal manually if needed
        const modal = document.getElementById('registerModal');
        if (modal) {
            const modalInstance = window.bootstrap.Modal.getInstance(modal);
            modalInstance.hide();
        }
    };

    return (
        <>
            <div className="content">
                <div className="container-fluid">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header border-info">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-lg">
                                                <select name="state" id="state" className="form-select">
                                                    <option value="">Select State</option>
                                                    <option value="35">Andaman & Nicobar Islands</option>
                                                    <option value="28">Andhra Pradesh</option>
                                                    <option value="12">Arunachal Pradesh</option>
                                                    <option value="18">Assam</option>
                                                    <option value="10">Bihar</option>
                                                </select>
                                            </div>
                                            <div className="col-lg">
                                                <select name="datefilter" className="form-select" id="datefilter">
                                                    <option value="Last 7 days" selected="">Select</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-2">
                                                <button type="submit" name="search"
                                                    className="btn btn-primary w-100">Search</button>
                                            </div>
                                            <div className="col-lg-1">
                                                <a href="list.html" name="search"
                                                    className="btn btn-outline-dark w-100">Reset</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="card-body">
                                    <div className="row g-0 align-items-center">
                                        <div className="col-sm-7 mb-3">
                                            <h6 className="fw-bold mb-0">
                                                Total User(s): <span>{users.length}</span>
                                            </h6>
                                        </div>

                                        <div className="col-sm-5 mb-3 text-end">
                                            <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#registerModal">
                                                Add User
                                            </button>
                                        </div>
                                    </div>

                                    <div className="table-responsive scrollbar">
                                        <table className="table text-center table-bordered table-striped fs--1 mb-0">
                                            <thead className="bg-primary text-white">
                                                <tr>
                                                    <th>Emp Code</th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>Contact</th>
                                                    <th>Designation</th>
                                                    <th>Department</th>
                                                    <th>Location</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8">No users found.</td>
                                                    </tr>
                                                ) : (
                                                    users.map((user, i) => (
                                                        <tr key={i}>
                                                            <td>{user.empCode}</td>
                                                            <td>{user.empName}</td>
                                                            <td>{user.gender}</td>
                                                            <td>{user.contact}</td>
                                                            <td>{user.designation}</td>
                                                            <td>{user.department}</td>
                                                            <td>{user.location}</td>
                                                            <td>
                                                                {/* Action buttons can go here */}
                                                                <button className="btn btn-sm btn-warning">Edit</button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="registerModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="registerModalLabel">Add User</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row g-3">
                                    {[{ label: 'Emp Code', name: 'empCode' },
                                    { label: 'Name', name: 'empName' },
                                    { label: 'Contact', name: 'contact' },
                                    { label: 'Designation', name: 'designation' },
                                    { label: 'Department', name: 'department' },
                                    { label: 'Location', name: 'location' }
                                    ].map((field, idx) => (
                                        <div key={idx} className="col-md-6">
                                            <label className="form-label">{field.label}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={field.name}
                                                value={formData[field.name]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ))}

                                    <div className="col-md-6">
                                        <label className="form-label">Gender</label>
                                        <select className="form-select" name="gender" value={formData.gender} onChange={handleChange}>
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Save User</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserList;
